/* eslint-disable import/prefer-default-export */
export const WS_STATUSES = {
  opened: 'opened',
  closed: 'closed',
};
